var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUrgentJobLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F8F3FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0007 13.9531C20.5587 13.9531 20.1587 14.2491 20.0317 14.6721L17.0317 24.6721C16.8397 25.3131 17.3307 25.9531 18.0007 25.9531H21.8757L21.0007 32.8281C20.8697 33.8751 22.2587 34.3931 22.8447 33.5161L30.8447 21.5161C31.2877 20.8511 30.7997 19.9531 30.0007 19.9531H25.3757L26.9387 15.2661C27.1537 14.6181 26.6837 13.9531 26.0007 13.9531C25.3757 13.9531 21.6257 13.9531 21.0007 13.9531Z",
    fill: "#7315DE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgentJobLogo);
export default __webpack_public_path__ + "static/media/urgent_job_logo.b060008c1b89018e046cb78484a589a5.svg";
export { ForwardRef as ReactComponent };